var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","disabled":_vm.isDisabled}},[(_vm.isSaving)?_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status","aria-hidden":"true"}}):_vm._e(),(_vm.isSaving)?_c('span',[_vm._v(" "+_vm._s(_vm.loadingText)+" ")]):_c('span',[_vm._v(" "+_vm._s(_vm.displayText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }